<mat-card>
    <mat-card-content fxLayout="row wrap" fxLayoutAlign="center center">
        <h2 fxFlex="100" fxLayoutAlign="center center">
        Redirecting you to the login service. Please Wait...
        </h2>
    </mat-card-content>
</mat-card>
